module.exports = __webpack_public_path__ + "media/images/countrysquared/am-757a866180c16ae0e8a763b18f0e1e36.svg";